import { IBoardData, Pair } from '../../Game/BoardUtils';
import BoardObject from '../../Tiles/BoardObject';
import Tile from '../../Tiles/Tile';
import { IBoardMap, TBoard } from '../../Game/BoardArrangement';
import { Rng } from '../../Utils/Rng';
// import BoardConnections from "../../Game/BoardConnections";

export interface IStateBoard {
    boardTiles: Array<Tile | BoardObject>;
    boardMap: IBoardMap;
    boardSize: [Pair, Pair];
    available: string[];
    availableMatches: Tile[];
    ready: boolean;
    blocked: boolean;
}

export const defaultStateBoard: IStateBoard = {
    available: [],
    boardMap: {},
    boardSize: [[7, 8], [0, 0]],
    boardTiles: [],
    availableMatches: [],
    ready: false,
    blocked: false,
};

export const createBoard = (levelData: IBoardData): (Tile | BoardObject)[] => {
    const tiles = levelData.tiles.slice(0).reduce((acc, tile) => {
        const boardTile = new Tile(tile.position, tile.type, acc.length.toString());
        acc.push(boardTile);
        return acc;
    }, []);

    if (!levelData.objects) {
        return [...tiles];
    }

    const objects = levelData.objects.slice(0).reduce(
        (acc, o) => {
            const boardObject = new BoardObject(o.position, (tiles.length + acc.length).toString());
            acc.push(boardObject);
            return acc;
        },
        [] as BoardObject[]
    );

    return [...tiles, ...objects];
};

export const getRandom = (min: number, max: number, seed?: string) => {
    const generator = new Rng(seed, true);
    const generate = seed ? generator.generate.bind(generator) : Math.random;
    return Math.floor(generate() * (max - min + 1)) + min;
};

export const getBoardPositions = (tiles: TBoard): number[][] => {
    return tiles.reduce((acc, t) => {
        const z = [...t.position];
        acc.push(z);
        return acc;
    }, []);
};
